var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12a8,8,0,1,0,8,8A8,8,0,0,0,20,12Zm0,15.158A7.158,7.158,0,1,1,27.158,20,7.152,7.152,0,0,1,20,27.158ZM20.589,20l2.653-2.653a.417.417,0,0,0-.589-.589L20,19.411l-2.653-2.653a.417.417,0,1,0-.589.589L19.411,20l-2.653,2.653a.417.417,0,1,0,.589.589L20,20.589l2.653,2.653a.417.417,0,0,0,.589-.589Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsCancel);
export default __webpack_public_path__ + "static/media/ctaIcons_Cancel.f79afbafad73272098a013410c438816.svg";
export { ForwardRef as ReactComponent };